export default class FormErrorBinder {
	constructor (containerEl) {
		this.containerEl = containerEl
		// this.containerEl に非表示のツールチップ追加
		this.#popup = document.createElement("bui-popup")
		this.#popup.innerHTML = /* html */`
			<div class="error-tooltip"></div>
		`
		this.#popup.SPShowTop = true
		this.#popup.position = "top"
		this.#popup.offsetY = true
		this.containerEl.appendChild(this.#popup)

		this.focusTarget = (e) => {
			this.#app(e)
		}

		this.blurTarget = () => {
			this.#blur()
		}
	}

	/** @type {HTMLElement}  */
	#popup = null

	/** @type {String[]}  */
	#messageBox = []

	/** @type {HTMLElement[]}  */
	#targets = []

	// unbind対象のグリッド要素
	#gridTargets = []

	/** @type {String}  */
	static ERROR_CLASS_NAME = "is-error"

	/** @type {String}  */
	static ERROR_MESSAGE_TITLE = "入力エラーがあります。"

	#app (e) {
		const tooltip = this.#popup.querySelector(".error-tooltip")
		tooltip.innerHTML = this.errors[e.currentTarget.name].join("<br>")
		const position = e.currentTarget.dataset.position || "top"
		if (position === "top" || position === "bottom") {
			this.#popup.showAtTarget({ target: e.currentTarget, offsetX: false, offsetY: true, additionalOffsetX: 0, additionalOffsetY: 4, position })
		} else {
			this.#popup.showAtTarget({ target: e.currentTarget, offsetX: true, offsetY: false, additionalOffsetX: 4, additionalOffsetY: 0, position })
		}
	}

	#blur () {
		this.#popup.hide()
	}

	async bind (errors) {
		this.unbind()
		Object.keys(errors).forEach(name => {
			// .が入っているものをグリッドのエラーとみなす
			if (name.includes(".")) {
				const regExpResult = /^(.*)\[([0-9]+)\].(.*)/.exec(name)
				let gridId, index, colId
				if (regExpResult != null) {
					// フィールド名からパラメータ番号を特定
					gridId = regExpResult[1]
					index = regExpResult[2]
					colId = regExpResult[3]
				}

				const grid = this.containerEl.querySelector(`bui-grid#${gridId}`)
				if (grid) {
					grid.addErrorByIndex(index, colId, errors[name])
					// グリッドはエラー色にするが、ツールチップ表示はできないのでメッセージボックスで表示しておく
					this.#messageBox = this.#messageBox.concat(errors[name])
					this.#gridTargets.push(grid)
					return
				}
			}

			// テキストボックスのみ取得
			const textTarget = this.containerEl.querySelector(`input[type="text"][name=${name}]`)
			if (textTarget) {
				textTarget.parentNode.classList.add(FormErrorBinder.ERROR_CLASS_NAME)
				if (!textTarget.classList.contains("no-tooltip")) {
					textTarget.addEventListener("focus", this.focusTarget)
					textTarget.addEventListener("blur", this.blurTarget)
				} else {
					this.#messageBox = this.#messageBox.concat(errors[name])
				}
				this.#targets.push(textTarget)
				return
			}
			const textAreaTarget = this.containerEl.querySelector(`textarea[name=${name}]`)
			if (textAreaTarget) {
				textAreaTarget.parentNode.classList.add(FormErrorBinder.ERROR_CLASS_NAME)
				if (!textAreaTarget.classList.contains("no-tooltip")) {
					textAreaTarget.addEventListener("focus", this.focusTarget)
					textAreaTarget.addEventListener("blur", this.blurTarget)
				} else {
					this.#messageBox = this.#messageBox.concat(errors[name])
				}
				this.#targets.push(textAreaTarget)
				return
			}

			// バインド対象がない場合はメッセージボックスで表示
			this.#messageBox = this.#messageBox.concat(errors[name])
		})
		this.errors = errors
		// テキストボックス以外のエラーメッセージをメッセージボックスで表示
		this.#messageBox = this.#messageBox.filter((v, i, a) => a.indexOf(v) === i) // distinct
		await window.bui.MessageBox.showErrorMessageBox({
			title: FormErrorBinder.ERROR_MESSAGE_TITLE,
			message: this.#messageBox.join("<br>"),
			okButtonName: "OK",
			persistent: true,
			showTitle: true
		})
	}

	unbind () {
		// エラー解除
		// ツールチップイベント解除
		this.#targets.forEach(target => {
			target.parentNode.classList.remove(FormErrorBinder.ERROR_CLASS_NAME)
			target.removeEventListener("focus", this.focusTarget)
			target.removeEventListener("blur", this.blurTarget)
		})

		this.#gridTargets.forEach(grid => {
			grid.clearErrors()
		})

		this.#targets = []
		this.#messageBox = []
		this.#gridTargets = []
	}
}
